"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _ampersandCollection = _interopRequireDefault(require("ampersand-collection"));

var _featureModel = _interopRequireDefault(require("./feature-model"));

// External dependencies.
// Local Dependencies

/**
 * Feature collection model.
 *
 * @description
 * This model contains a collection of features under a specific collection
 * group.
 */
var FeatureCollection = _ampersandCollection.default.extend({
  /**
   * The unique identifier for the models in this collection.
   *
   * @type {string}
   */
  mainIndex: 'key',

  /**
   * The type of model this collection can contain.
   *
   * @type {Class}
   */
  model: _featureModel.default
});

var _default = FeatureCollection;
exports.default = _default;
//# sourceMappingURL=feature-collection.js.map
